/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) · Contact page
   English is the source of truth in contact.html; this file supplies the
   Swedish counterpart for each contact.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) and the postal address stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Om Dr. Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Hör av dig',
    'contact.title': 'Frågor,<br>förfrågningar,<br><em>eller bara hej.</em>',
    'contact.intro': 'Pressförfrågningar, återförsäljarförfrågningar, frågor om rutinen, eller något däremellan. Vi läser varje meddelande. Svar kommer vanligtvis inom två arbetsdagar.',

    /* ── Reach us ── */
    'contact.reach': 'Nå oss',
    'contact.email.label': 'E-post',
    'contact.email.meta': 'Bäst för detaljerade frågor',
    'contact.phone.label': 'Telefon',
    'contact.phone.meta': 'Mån – fre · 9–17 EST',
    'contact.address.label': 'Adress',
    'contact.address.meta': 'Returer &amp; korrespondens',
    'contact.social.label': 'Hitta oss i sociala medier',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Skicka en förfrågan',
    'contact.form.name': 'Namn',
    'contact.form.subject': 'Ämne',
    'contact.form.email': 'E-postadress',
    'contact.form.message': 'Meddelande',
    'contact.form.send': 'Skicka',
    'contact.form.success': 'Tack för att du hör av dig · vi återkommer inom 1–2 arbetsdagar.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Svarstider',
    'contact.hours.email.label': 'E-post',
    'contact.hours.email.val': 'Inom 2 arbetsdagar',
    'contact.hours.phone.label': 'Telefon',
    'contact.hours.phone.val': '9–17 EST',
    'contact.hours.press.label': 'Press',
    'contact.hours.press.val': 'Inom 1 arbetsdag',

    /* ── CTA ── */
    'contact.cta.title': 'Osäker på vilket serum som passar dig?',
    'contact.cta.body': 'Discovery Kit innehåller fickformat av alla fem serum. De flesta vet inom några dagar.',
    'contact.cta.button': 'Skaffa Discovery Kit'

  });
})();
